$(document).on('change', '.change-amount-wish', function (){
    $(this).prop('disabled', true);
    changeAmountWish($(this).data('product'), $(this).val());
});

$(document).on('click', '.cnt-button.plus-wish', function (e) {
    e.preventDefault();
    let input = $(this).parent().find('input');
    input.val(parseInt(input.val()) + 1);

    input.prop('disabled', true);
    changeAmountWish(input.data('product'), input.val());
});

$(document).on('click', '.cnt-button.minus-wish', function (e) {
    e.preventDefault();
    let input = $(this).parent().find('input');
    let val = parseInt(input.val()) - 1;
    if(val < 1){
        return;
    }
    input.val(val);
    input.prop('disabled', true);
    changeAmountWish(input.data('product'), input.val());
});

function changeAmountWish(product, value){
    let href = $(document).find("#change-amount-wish");
    let formData = {};

    formData.product = product;
    formData.value = value;

    $.nette.ajax({
        url: href.data("href"),
        data: formData,
        type: 'POST',
        off: {
            snippets: true
        },
        success: function (payload) {
        },
        error: function (err) {
        }
    });
}



$(document).on('change', '.change-amount', function (){
    $(this).prop('disabled', true);
    changeAmount($(this).data('product'), $(this).val());
});

$(document).on('click', '.cnt-button.plus-basket', function (e) {
    e.preventDefault();
    let input = $(this).parent().find('input');
    input.val(parseInt(input.val()) + 1);

    input.prop('disabled', true);
    changeAmount(input.data('product'), input.val());
});

$(document).on('click', '.cnt-button.minus-basket', function (e) {
    e.preventDefault();
    let input = $(this).parent().find('input');
    let val = parseInt(input.val()) - 1;
    if(val < 1){
        return;
    }
    input.val(val);
    input.prop('disabled', true);
    changeAmount(input.data('product'), input.val());
});

function changeAmount(product, value){
    let href = $(document).find("#change-amount");
    let formData = {};

    formData.product = product;
    formData.value = value;

    console.log(href.data("href"));

    $.nette.ajax({
        url: href.data("href"),
        data: formData,
        type: 'POST',
        off: {
            snippets: true
        },
        success: function (payload) {
        },
        error: function (err) {
        }
    });
}

$(document).on('change', '.change-price', function (){
    $(this).prop('disabled', true);
    changePrice($(this).data('product'), $(this).val());
});

$(document).on('click', '.cnt-button.plus-price', function (e) {
    e.preventDefault();
    let input = $(this).parent().find('input');
    input.val(parseInt(input.val()) + 1);

    input.prop('disabled', true);
    changePrice(input.data('product'), input.val());
});

$(document).on('click', '.cnt-button.minus-price', function (e) {
    e.preventDefault();
    let input = $(this).parent().find('input');
    let val = parseInt(input.val()) - 1;
    if(val < 1){
        return;
    }
    input.val(val);
    input.prop('disabled', true);
    changePrice(input.data('product'), input.val());
});

function changePrice(product, value){
    let href = $(document).find("#change-price");
    let formData = {};

    formData.product = product;
    formData.value = value;

    $.nette.ajax({
        url: href.data("href"),
        data: formData,
        type: 'POST',
        off: {
            snippets: true
        },
        success: function (payload) {
        },
        error: function (err) {
        }
    });
}

$(document).on('change', '.delivery-radio', function (){
    console.log("change");
    let href = $(this).closest(".shipping-type-container").data('href');
    let formData = {};
    formData.supplier = $(this).data('supplier');
    formData.method = $(this).data('method');

    $.nette.ajax({
        url: href,
        data: formData,
        type: 'POST',
        off: {
            snippets: true
        },
        success: function (payload) {
        },
        error: function (err) {
        }
    });
});

$(document).on('click', '#virtualSaveDeliveryDataForm', function (e){
   e.preventDefault();
   $(document).find('#sendDeliveryDataForm').click();
});

$(document).on('change', '#deliveryDataSelect', function() {
    $.nette.ajax({
        url: $(document).find("#prealoadHandle").data('href'),
        type: 'POST',
        data: {
            deliveryData: $(this).val()
        },
        off: {
            snippets: true
        }
    });
});